import { Dispatch, SetStateAction, useState } from 'react';

export type LegendFilter = {
  key: string;
  value: string[];
  filter: string;
};

export const DEFAULT_LEGEND_FILTER: LegendFilter = {
  key: '',
  value: [],
  filter: '',
};

export type SetLegendFilter = Dispatch<SetStateAction<LegendFilter>>;

export const useLegendFilter = () => {
  const [legendFilter, setLegendFilter] = useState<LegendFilter>({ ...DEFAULT_LEGEND_FILTER });

  return {
    legendFilter,
    setLegendFilter,
  };
};
